import { createContext, useContext, useEffect, useState } from "react";
import UserService from "../services/user.service";
import MenuService from "../services/menu.service";

export const AuthContext = createContext();

const { Provider } = AuthContext;

export function useAuthContext() {
  const contextValues = useContext(AuthContext);
  return contextValues;
}

export function AuthContextProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(undefined);
  const [authToken, setAuthToken] = useState(undefined);
  const [user, setUser] = useState();
  const [menuState, setMenuState] = useState(true);
  const [menuList, setMenuList] = useState(undefined);

  // Effects
  useEffect(() => {
    const hasToken = localStorage.getItem(AUTH_STATE);
    if (hasToken) {
      userProfile(hasToken.authToken);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  function logOutAuthContext() {
    setIsLoggedIn(false);
    setAuthToken(undefined);
    setUser();
    setMenuList(undefined);
  }

  async function userProfile(token) {
    try {
      setIsLoading(true);
      const resp = await UserService.profile();
      if (resp.data && resp.data.success) {
        setAuthToken(token);
        setIsLoggedIn(true);
        setUser(resp.data.data);
        await fetchSideMenuData();
      } else {
        logOutAuthContext();
        removeAuthStorage();
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.error("User Profile error catch => ", err);
      logOutAuthContext();
      removeAuthStorage();
    }
  }

  async function fetchSideMenuData() {
    try {
      const resp = await MenuService.getAll();
      if (resp.data.success) {
        setMenuList(
          resp.data.data && resp.data.data.length ? resp.data.data : []
        );
      }
    } catch (err) {
      console.error("Side Menus error catch => ", err);
      setIsLoading(false);
    }
  }

  return (
    <Provider
      value={{
        isLoading,
        setIsLoading,
        isLoggedIn,
        setIsLoggedIn,
        authToken,
        setAuthToken,
        user,
        setUser,
        menuState,
        setMenuState,
        menuList,
        setMenuList,
        logOutAuthContext,
      }}
    >
      {children}
    </Provider>
  );
}

const AUTH_STATE = "IQVIA_TSA_AUTH_STATE";

export function getAuthStorage() {
  return localStorage.getItem(AUTH_STATE)
    ? JSON.parse(localStorage.getItem(AUTH_STATE))
    : { authToken: null };
}

export function setAuthStorage(authToken) {
  localStorage.setItem(AUTH_STATE, JSON.stringify({ authToken }));
}

export function removeAuthStorage() {
  if (localStorage.getItem(AUTH_STATE)) localStorage.removeItem(AUTH_STATE);
}
